import { PlayerInitialStateModel } from './types';

const playerInitialValue: PlayerInitialStateModel = {
  playerActive: false,
  playerPaused: false,
};

export default playerInitialValue;
